<template>
    <div class="colorFondo">
        <v-container fluid class="white elevation-3 margen d-flex justify-space-around">
            <h1>Órdenes de compra</h1>
            <v-btn color="blue-grey" class="ma-2 white--text" @click="dialog = true">
              Subir Archivo
              <v-icon right dark> mdi-cloud-upload </v-icon>
            </v-btn>
            <v-btn class="mt-2 success" to="/NuevaOrdenCompra">Nueva orden de compra</v-btn>
        </v-container>
        <!-- dialog-->
        <v-dialog v-model="dialog" width="600">
          <v-card>
            <v-card-title>Archivo</v-card-title>
            <v-divider></v-divider>
            <v-card>
              <v-file-input
                v-model="file"
                color="light-blue darken-4"
                counter
                label="File input"
                placeholder="Select your files"
                prepend-icon="mdi-paperclip"
                outlined
                :show-size="1000"
                class="mx-3"
              >
              
                <template v-slot:selection="{ index, text }">
                  <v-chip v-if="index < 2" color="grey darken-1" dark label small>
                    {{ text }}
                  </v-chip>

                  <span
                    v-else-if="index === 2"
                    class="text-overline grey--text text--darken-3 mx-2"
                  >
                    +{{ files.length - 2 }} File(s)
                  </span>
                  <v-spacer></v-spacer>
                </template>
              </v-file-input>

              <v-card-actions class="d-flex justify-space-around">
                <v-btn color="grey darken-1" dark @click="dialog = false">
                  Cerrar</v-btn
                >
                <v-btn color="green darken-1" dark @click="reprogramarSeguimiento">
                  Mostrar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-card>
        </v-dialog>
        <!--fin dialogo-->
        <v-card class="ma-3">
          <v-row class="mx-3 mt-3">
            <v-spacer></v-spacer>
            <v-text-field
            class="ma-3"
            v-model="buscador"
            label="Buscar"
            append-icon="mdi-magnify"
            single-line
            />

          </v-row>

          <v-data-table
          :headers="columnas"
          :items="ordenes"
          :search="buscador"
          :loading="cargando"
          item-class="allB"
          >
          <template v-slot:[`item.detalleOrden`]="{ item }">
            <div>
              <ModalDetalleOrden
              :infoOrden ="item"
              :key="item.ORDEN_COMPRA_ID"/>
            </div>
          </template>

          <template v-slot:[`item.actionFinalizar`]="{ item }">
            <div>
              <ModalFinalizar
              :infoOrden ="item"
              @actualizarTabla ="obtenerOrdenes"
              :key="item.ORDEN_ID"/>
            </div>
          </template>

          <template v-slot:[`item.actionEliminar`]="{ item }">
            <div>
              <ModalEliminar
              :infoOrden ="item"
              @actualizarTabla ="obtenerOrdenes"
              :key="item.ORDEN_COMPRA_ID"/>
            </div>
          </template>

          <template slot="no-data">
            <v-alert class="my-2" :value="true" type="info" color="orange lighten-2" >
              No se encontró información para mostrar.
            </v-alert>
          </template>
          </v-data-table>
      </v-card>
    
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
import ModalDetalleOrden from './Modals/ModalDetalleOrden.vue'
import ModalFinalizar from './Modals/ModalFinalizar'
import ModalEliminar from './Modals/ModalEliminar'
//import { defineComponent } from '@vue/composition-api'

export default {
  components: {ModalDetalleOrden, ModalFinalizar, ModalEliminar},
    data(){
        return{
            ordenes: [],
            buscador:"",
            cargando:false,
            dialog: false,
            file: null,

            columnas:[
                {text:"Folio",        value:"FOLIO"},
                {text:"Proveedor",    value:"PROVEEDOR"},
                {text:"Fecha",        value:"FECHA"},
                {text:"Folio MSP",    value:"FOLIO_MSP"},
                {text:"Descuento PP", value:"DESCUENTO_PP"},
                {text:"Ver Detalle",  value:"detalleOrden"},
                {text:"Orden entregada", value:"actionFinalizar"},
                {text:"Cancelar orden", value:"actionEliminar"}
            ],
        }
    },
    computed: {
      ...mapGetters(['getURLAPI','getFechaActual'])  
    },

    methods:{
        async obtenerOrdenes(){
            this.cargando  = true;
            this.ordenes = (await axios.get(`${this.getURLAPI}/Ordenes/getOrdenes`)).data
            //console.log(this.ordenes);
            this.cargando = false;
        },
        reprogramarSeguimiento(){ 
          let datosForm = new FormData();
          if(this.file == null)
          {
            alert("No has seleccionado el archivo de seguimiento.");
            return;
          }
          else if(this.archivoExcel !== "")
          {
            datosForm.append("EXCELREPRO", this.file);
            axios
              .post(`${this.getURLAPI}/Ordenes/reprogramarOrdenes`, datosForm)
              .then(({ data }) => {
                //this.datosExcel
                console.log(data);
                if (data.STATUS !== "ERROR") {
                  this.cargando = false;
                  // this.$emit('mostrarSnackbar', {snackbar:true,msg:data.MSG});
                  this.$root.vtoast.show({
                    message: data.MSG,
                    color:
                      data.STATUS == "OK" ? "success darken-2" : "red darken-2",
                    timer: 10000,
                    icon:
                      data.STATUS == "OK"
                        ? "mdi-check"
                        : "mdi-alert-circle-outline",
                  });
                  this.$router.push("/OrdenesDeCompra");
                } else {
                  this.$root.vtoast.show({
                    message: data.MSG,
                    color: "red darken-2",
                    timer: 10000,
                    icon: "mdi-alert-circle-outline",
                  });
                }
              })
          }
        },
    },

    created() {
        document.title = "Órdenes de compra | Bombas y Suministros del Norte";
        this.obtenerOrdenes();
    }
}
</script>
